import create from "zustand";

export type WorkspaceController = {
	activeSpaceId: number | null;
	refresh: () => Promise<void>;
	switchToEditMode: () => void;
	cancelEditMode: () => void;
};

export type WorkspaceControllerStoreData = {
	controller: OptionalModel<WorkspaceController>;
	setController: (controller: WorkspaceController) => (() => void);
	clearController: () => void;
};

export const useWorkspaceControllerStore = create<WorkspaceControllerStoreData>(
	(set) => ({
		controller: { isSet: false },
		setController: (controller: WorkspaceController): (() => void) => {
			set({
				controller: {
					isSet: true,
					value: controller
				}
			});

			return () => set({ controller: { isSet: false } });
		},
		clearController: (): void => {
			set({ controller: { isSet: false } });
		}
	})
);